<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect,
  },
  inheritAttrs: false,
  props: {
    value: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    placeholder: {
      type: String,
      default: 'Select option',
    },
    label: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      modelValue: this.value,
      options: [],
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update', value)
      },
    },
  },
  methods: {
    addTag(newTag) {
      const tag = newTag
      this.options.push(tag)
      this.value.push(tag)
    },
  },
}
</script>

<template>
  <div class="position-relative">
    <div :class="$style.labelContainer">
      <div>
        <p :class="$style.label" class="p1">{{ label }}:</p>
      </div>
    </div>

    <Multiselect
      v-model="model"
      class="motto-multi-select motto-multi-select-input-multiple"
      :disabled="disabled"
      :placeholder="placeholder"
      :options="options"
      :taggable="true"
      :multiple="true"
      :show-labels="false"
      @tag="addTag"
      @input="
        (changedValue) => {
          $emit('input', changedValue)
        }
      " />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.select {
  width: 100%;
  height: 40px;
  padding: 10px 45px 10px 16px;
  font-size: 16px;
  color: $dark-gray;
  cursor: pointer;
  background-color: $white;
  border: 0.5px $light-gray solid;
  border-radius: 36px;
  outline: none;
  appearance: none;
}

.errorContainer {
  position: absolute;
  right: 0;
  left: 0;

  .errorMessage {
    @extend %error-message;

    text-align: center;
  }
}

.selectDownArrow {
  position: absolute;
  top: 12px;
  right: 18px;
  color: $gray;
  pointer-events: none;
}

.labelContainer {
  position: relative;
  display: flex;
  align-items: center;

  div[data-tooltip-icon] {
    position: initial;
    display: flex;
    align-items: center;
    margin-left: 8px;
  }
}

.label {
  margin-top: 10px;
  margin-bottom: 10px;
  color: $dark-gray;
}
</style>
